import React from 'react'
import Navbar from './Navbar'
import Footer from './Footer'
import Section1 from './Section1';
import Productitem from './ProductItem';
import ProductImage from '../components/assets/img/ImageProduct'
export default function Product() {
    return (
        <>
            <Navbar />
            <main className="main">
                <Section1 sectionName={"Product"}/>
                <section class="section2">
                    <div className="section_container">
                    <div class="product_sec2_container">
                        <ul>
                            <Productitem productImage = {ProductImage.product1} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product2} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product3} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product4} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product5} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product6} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product7} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product8} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product9} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product10} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product11} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product12} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product13} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product14} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product15} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product16} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product17} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product18} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product19} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product20} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product21} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product22} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product23} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product24} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product25} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product26} productName = {"BLAST FREEZER"}/>
                            <Productitem productImage = {ProductImage.product27} productName = {"BLAST FREEZER"}/>
                            
                        </ul>
                    </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    )
}
